import React, { FC, InputHTMLAttributes, ReactElement } from 'react';

import { Field as FormikField, FieldProps as FormikFieldProps } from 'formik';

import { ErrorMessage } from './components/error-message';
import { LabelWrapper, LableWrapperProps } from './components/label-wrapper';
import { styles } from './styles';

export type FieldProps = InputHTMLAttributes<HTMLInputElement> &
  LableWrapperProps & {
    name: string;
    children: (fieldProps: FormikFieldProps) => React.ReactNode;
    label?: string;
    labelIcon?: ReactElement;
  };

export const Field: FC<FieldProps> = ({ name, label, labelIcon, className, children, isFocusOnLabelEnabled = true }) => (
  <FormikField name={name}>
    {(fieldProps: FormikFieldProps) => {
      return (
        <div css={styles} className={className}>
          <LabelWrapper isFocusOnLabelEnabled={isFocusOnLabelEnabled}>
            <>
              {label ? (
                <div className='label'>
                  {label}
                  {labelIcon}
                </div>
              ) : null}

              <div>{children(fieldProps)}</div>
            </>
          </LabelWrapper>
          <ErrorMessage className='error-message' error={fieldProps.meta.touched ? fieldProps.meta.error : undefined} />
        </div>
      );
    }}
  </FormikField>
);
